import { render } from "./PlayersList.vue?vue&type=template&id=5a5cc666"
import script from "./PlayersList.vue?vue&type=script&lang=js"
export * from "./PlayersList.vue?vue&type=script&lang=js"

import "./PlayersList.vue?vue&type=style&index=0&id=5a5cc666&lang=css"

import exportComponent from "/go/src/asuzs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__